import { CronSunsetSunriseVariables } from '@smartlife-redux-state/common';
import { CronRelativeToSun } from '../../components/CronRelativeToSun';

// eslint-disable-next-line import/prefer-default-export
export const CronSunsetSunrise: React.FC<{
  variables: CronSunsetSunriseVariables;
  onChange: (data: CronSunsetSunriseVariables) => void;
}> = ({ variables, onChange }) => <CronRelativeToSun variables={variables} onChange={onChange} />;
